module.exports = __webpack_public_path__ + "img/character_resize_fuse.12564856.png";